import React from 'react';
import { Box } from '@mui/material';
import { PRES, TYPE } from '../chrome';

interface EmptyStateProps {
  title: string;
  body?: string;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, body, action }) => (
  <Box sx={{ py: 8, px: 3, textAlign: 'center', maxWidth: 420, mx: 'auto' }}>
    <Box sx={{ fontFamily: TYPE.ui, ...TYPE.title, color: PRES.textPrimary, mb: 1 }}>{title}</Box>
    {body && (
      <Box sx={{ fontFamily: TYPE.ui, ...TYPE.body, color: PRES.textSecondary, mb: action ? 2.5 : 0 }}>
        {body}
      </Box>
    )}
    {action}
  </Box>
);

export default EmptyState;
